export const NR_ROWS = 15;
//# sourceMappingURL=NR_ROWS.js.map